export default {"src":"/_next/static/media/support.053549e6.svg","height":24,"width":24};